<template>
  <LayoutBasic
    v-if="page === 'showing'"
  >
    <div id="list" />
    <div class="page__is-expanded pt7 pt-m--10 pb-m--5">
      <div class="pv10 pv-l--12">
        <div
          class="mb8 mb-xl--12 fw4 fs7"
          style="letter-spacing: 0.3rem;"
        >
          - 基金會活動 -
        </div>
        <div
          class="page__content--90 page__content-l--80"
          style="max-width: 70rem; justify-content: center;"
        >
          <div
            v-for="(
              { title, subTitle, content, isHiding, image },
              index) in seasonalEvents"
            :key="'seasonal-event'+ index"
            @click="{
              if (isHiding === undefined) {
                $router.push('/seasonalEvents/'+title)
              } else {$router.push('/giftAdopt');}
            }"
            :id="'seasonal-event--'+ index"
            class="seasonal-event row--start mb8"
            style="cursor: pointer;"
          >
            <img
              :src="image || computedImage(title)"
              alt=""
              class="seasonal-event-image image--size-y-fit"
              style="max-width: 15rem;"
            >
            <div
              class="seasonal-event__text pt3 pt-m--0 pl-m--5 pl-l--8"
            >
              <div
                class="row--start align--left fs4 fw4"
                style="line-height: 1.2;"
              >
                {{ title }}
              </div>
              <div class="row--start fs1 mv3 mv-l--4">
                {{ subTitle }}
              </div>
              <span
                class="page__text align--left mb5 mb-m--3 mb-l--4"
                style="display: -webkit-box;
                  -webkit-box-orient: vertical;
                  -webkit-line-clamp: 3;
                  white-space: normal;
                  overflow: hidden;"
              >
                {{ content }}
              </span>
              <div
                class="seasonal-event__button fs1 ba--secondary border-radius--1
                  bc__hover--tertiary-light fc__hover--white ph3 pv2"
                style="display: flex; align-items: center;"
              >
                閱讀更多
                <font-awesome-icon
                  :icon="['fas', 'chevron-right']"
                  class="fw1 fs1 ml2"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </LayoutBasic>
</template>
<script>
import {
  onMounted, ref,
} from 'vue';
import store from '@/store/index';
import clinic from '@/clinic';

export default {
  setup() {
    const page = ref('initialize');
    const seasonalEvents = ref(null);

    function computedImage(title) {
      return `${clinic.urls.baseImageUrl}/seasonalEvents/${title}/1.jpg`;
    }

    onMounted(async () => {
      if (!store.member.jwt) {
        await store.member.getInfo('drx5-web');
      }
      ({
        seasonalEvents: seasonalEvents.value,
      } = store.member.info);
      page.value = 'showing';
    });

    return {
      page,
      window,
      seasonalEvents,
      computedImage,
    };
  },
};
</script>
<style lang="scss" scoped>
.seasonal-event {
  max-width: 30rem;
  display: flex;
  flex-direction: column;
}
.seasonal-event__text {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
}
.seasonal-event-image {
  max-height: 10rem;
}
.seasonal-event__button {
  align-self: self-end;
}

@media (min-width: 768px) {
  .seasonal-event {
    flex-direction: row;
    max-width: none;
  }
  .seasonal-event-image {
    max-width: 15rem;
    max-height: 12rem;
  }
  .seasonal-event__button {
    align-self: self-start;
  }
}
@media (min-width: 992px) {
  .seasonal-event-image {
    max-width: 20rem;
    max-height: 15rem;
  }
}
</style>
